import { useEffect, useState } from "react";

/**
 * Thin gold accent bar under the sticky header that fills based on scroll depth.
 * Useful on long article-style pages (Blog, Extension Rules, How It Works, FAQ)
 * as a subtle "reading progress" cue. Hidden on `/quote` where the header itself
 * isn't sticky and the wizard has its own step tracker.
 */
export default function ReadingProgress({ hide = false }) {
  const [pct, setPct] = useState(0);

  useEffect(() => {
    if (hide) return undefined;
    let raf = 0;
    const compute = () => {
      raf = 0;
      const doc = document.documentElement;
      const scrollable = (doc.scrollHeight - doc.clientHeight) || 1;
      const p = Math.min(100, Math.max(0, (window.scrollY / scrollable) * 100));
      setPct(p);
    };
    const onScroll = () => {
      if (raf) return;
      raf = window.requestAnimationFrame(compute);
    };
    compute();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    return () => {
      if (raf) window.cancelAnimationFrame(raf);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [hide]);

  if (hide) return null;
  return (
    <div
      data-testid="reading-progress"
      aria-hidden="true"
      className="h-[2px] bg-transparent"
    >
      <div
        className="h-full bg-[#C79A3B] transition-[width] duration-150 ease-out"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
